import { useState, useEffect } from 'react';

interface ImageLoadState {
  loading: boolean;
  error: boolean;
  loaded: boolean;
}

export const useProgressiveImage = (src: string, placeholder?: string) => {
  const [imageState, setImageState] = useState<ImageLoadState>({
    loading: true,
    error: false,
    loaded: false
  });
  const [currentSrc, setCurrentSrc] = useState(placeholder || '');

  useEffect(() => {
    if (!src) return;

    setImageState({ loading: true, error: false, loaded: false });
    
    const img = new Image();
    
    img.onload = () => {
      setCurrentSrc(src);
      setImageState({ loading: false, error: false, loaded: true });
    };
    
    img.onerror = () => {
      setImageState({ loading: false, error: true, loaded: false });
    };
    
    img.src = src;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src]);

  return {
    src: currentSrc,
    ...imageState
  };
};